<template>
  <div class="MdImg" :class="imgClass">
    <div>
      <a :style="aspectStyle">
        <span :style="imgStyle"></span>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'lineFlexImgElement',
  props: {
    data: {
      type: Object,
    },
  },
  computed: {
    imgClass() {
      return {
        ExCover: this.data.aspectMode === 'cover',
        ExFit: this.data.aspectMode === 'fit',
        ExFull: this.data.size === 'full',
        ExXXs: this.data.size === 'xxs',
        ExXs: this.data.size === 'xs',
        ExSm: this.data.size === 'sm',
        ExMd: this.data.size === 'md',
        ExLg: this.data.size === 'lg',
        ExXl: this.data.size === 'xl',
        ExXXl: this.data.size === 'xxl',
        Ex3Xl: this.data.size === '3xl',
        Ex4Xl: this.data.size === '4xl',
        Ex5Xl: this.data.size === '5xl',
        fl0: this.data.flex === 0,
        fl1: this.data.flex === 1,
        fl2: this.data.flex === 2,
        fl3: this.data.flex === 3,
        grvC: this.data.gravity === 'center',
        grvB: this.data.gravity === 'bottom',
        ExAlgC: this.data.align === 'center',
        ExAlgE: this.data.align === 'end',
        ExAbs: this.data.position === 'absolute',
      };
    },
    aspectStyle() {
      if (this.data.aspectRatio) {
        const s = this.data.aspectRatio.split(':');
        const result = `${(((+s[1]) * 100) / (+s[0])).toFixed(2)}%`;
        return {
          paddingBottom: result,
        };
      }
      return {
        paddingBottom: '100%',
      };
    },
    imgStyle() {
      return {
        backgroundImage: `url('${this.data.url}')` || '',
        backgroundColor: this.data.backgroundColor || '',
      };
    },
  },
};
</script>
